/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resources_Orderdayentryclose_Name3Inputs */

const en_resources_orderdayentryclose_name3 = /** @type {(inputs: Resources_Orderdayentryclose_Name3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entry close history`)
};

const fr_resources_orderdayentryclose_name3 = /** @type {(inputs: Resources_Orderdayentryclose_Name3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historique fin de saisie`)
};

const es_resources_orderdayentryclose_name3 = /** @type {(inputs: Resources_Orderdayentryclose_Name3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Historial de cierre de entrada`)
};

const de_resources_orderdayentryclose_name3 = /** @type {(inputs: Resources_Orderdayentryclose_Name3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingabeabschluss-Verlauf`)
};

const nl_resources_orderdayentryclose_name3 = /** @type {(inputs: Resources_Orderdayentryclose_Name3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invoer afsluiting geschiedenis`)
};

/**
* | output |
* | --- |
* | "Entry close history" |
*
* @param {Resources_Orderdayentryclose_Name3Inputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "de" | "nl" }} options
* @returns {LocalizedString}
*/
const resources_orderdayentryclose_name3 = /** @type {((inputs?: Resources_Orderdayentryclose_Name3Inputs, options?: { locale?: "en" | "fr" | "es" | "de" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resources_Orderdayentryclose_Name3Inputs, { locale?: "en" | "fr" | "es" | "de" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resources_orderdayentryclose_name3(inputs)
	if (locale === "fr") return fr_resources_orderdayentryclose_name3(inputs)
	if (locale === "es") return es_resources_orderdayentryclose_name3(inputs)
	if (locale === "de") return de_resources_orderdayentryclose_name3(inputs)
	return nl_resources_orderdayentryclose_name3(inputs)
});
export { resources_orderdayentryclose_name3 as "resources.orderDayEntryClose.name" }